import cx from 'classnames';
import s from './StatusIcon.module.scss';
import {
  IconSuccess,
  IconError,
  IconPending,
} from '@/shared/ui/Icons';

type StatusIconProps = {
  status: 'success' | 'warning' | 'danger';
  className?: string;
  titleClassName?: string;
  title?: string;
}

const ICONS = {
  success: IconSuccess,
  warning: IconPending,
  danger: IconError,
}

const ICONS_CLASSES = {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
}

const StatusIcon = (props: StatusIconProps) => {
  const {
    status = 'success',
    className = '',
    titleClassName = '',
    title = '',
  } = props;

  const Icon = ICONS[status];
  const variant = ICONS_CLASSES[status];

  return (
    <div
      className={cx(s.root, s[variant])}
    >
      <Icon className={cx(s.iconRoot, s[variant], className, {
        'mr-1': !!title
      })}/>
      <span className={titleClassName}>{title}</span>
    </div>
  );
}

export default StatusIcon;
